import { apiUrl } from '../config/api';
import { refreshCurrentUser } from './refreshCurrentUser';

export function getCompanyLogoApiUrl() {
  return apiUrl('/api/users/company-logo');
}

/** Resolve logo fetch targets for PDF export (most reliable first). */
export async function resolveCompanyLogoSources(userEmail, companyLogoUrl = null) {
  const sources = [];

  if (userEmail) {
    sources.push({ url: getCompanyLogoApiUrl(), userEmail });
  }
  if (companyLogoUrl) {
    sources.push({ url: companyLogoUrl, userEmail });
  }

  const sidebarUrl = findSidebarCompanyLogoUrl();
  if (sidebarUrl && !sources.some((s) => s.url === sidebarUrl)) {
    sources.push({ url: sidebarUrl, userEmail });
  }

  if (!sources.length && userEmail) {
    const user = await refreshCurrentUser(userEmail);
    if (user?.company_logo_url) {
      const url = apiUrl(user.company_logo_url);
      if (!sources.some((s) => s.url === url)) {
        sources.push({ url, userEmail });
      }
    }
  }

  return sources;
}

function findSidebarCompanyLogoUrl() {
  const imgs = document.querySelectorAll('aside img');
  for (const img of imgs) {
    if (img.src && img.src.includes('/uploads/')) {
      return img.src;
    }
  }
  return null;
}
